/**
 * A modal displayed when clicking "Flag" on discussion items, which allows
 * the user to select a reason for the flag.
 */
import {t} from "@lingui/core/macro";
import * as React from "react";

import BaseFlagModal from "./base-flag-modal.tsx";
import type {Action} from "./types.ts";

type Props = {
    isComputerProgramming: boolean;
    // A function that will close the modal once called
    closeModal: () => unknown;
    onSelectReason: (arg1: string, arg2: string) => unknown;
    // used in fixtures only
    inFixture?: boolean;
};

const ScratchpadFlagModal = (props: Props): React.ReactElement => {
    const {isComputerProgramming, ...restProps} = props;

    const bodyText = t`Please consult our project guidelines for what we consider to be an appropriate project.`;

    const actions: Array<Action> = [
        {
            name: "inappropriate",
            header: t`abuse`,
            examples: [
                t`disrespectful or offensive`,
                t`advertisement for off-site company/service`,
            ],
        },

        {
            name: "plagiarism",
            header: t`plagiarism`,
            examples: [
                t`not a spin-off and not giving credit to original author`,
            ],
        },

        {
            name: "vote-soliciting",
            header: t`soliciting votes`,
            examples: [
                t`requesting votes`,
                t`making promises for votes`,
                t`receiving votes from a voting ring`,
            ],
        },
    ];

    if (isComputerProgramming) {
        actions.push({
            name: "using-disallowed",
            header: t`using disallowed functionality`,
            examples: [
                t`accessing externals or the DOM to go beyond allowed functionality`,
                t`examples: playing sounds inappropriately, using localStorage`,
            ],
        });
    }

    actions.push({
        name: "doesnotbelong",
        header: t`off-topic`,
        examples: [
            t`petitions to change the site`,
            t`contentious projects about politics, religion/atheism, or personal issues`,
        ],
    });

    return (
        <BaseFlagModal {...restProps} bodyText={bodyText} actions={actions} />
    );
};

export default ScratchpadFlagModal;
